import { ICommonConfig } from '../shared/interfaces/main-config.interface';

export const MAIN = {
  // dynamics
  web_api_path: '/api/data/v9.2/',
  widget_script_path: '/webresources/Widget/msdyn_ciLibrary.js',
  cif_id: 'CIFMainLibrary',
  // phone prefix
  phone_prefix: '00',
  solgari: 'SOLGARI_LOGGER',
  // get token credentials for MSAL
  tenantId: 'common',
  clientId: '25802dc4-8081-4050-abb3-6510c0f3b897',
  clientInstanceUrl: 'https://login.microsoftonline.com',
  apiScope: 'api://25802dc4-8081-4050-abb3-6510c0f3b897/access_as_user',
  lsTokenKey: 'jwtToken',
  lsTenantIdKey: 'tenantId',
  lsAutoAnswerToggleKey: 'isAutoAnswer',
  lsAutoAnswerTimerKey: 'AutoAnswerTimer',
  lsWrapUpToggleAllCallsKey: 'WrapUpForAllCalls',
  // dialer
  DIALER_GAP: 5000,

  // dev variables
  LS_SETTINGS: 'SG_SETTINGS',
  LS_IS_DEV: 'dev',
  lsSipCreds: 'sipCredentials',
};

export const COMMON: ICommonConfig = {
  DEFAULT_SETTINGS: {
    dialer: {
      wrapUpTime: MAIN.DIALER_GAP,
    },
    notification: {
      inboundCall: true,
      incomingMessage: true,
    },
  },
  UNKNOWN: 'Unknown Entity',
  UNKNOWN_ENTITY: {
    id: null,
    fullName: 'Unknown',
    initialPhone: 'Unknown',
    phone: 'Unknown',
    secondPhone: 'Unknown',
    type: null,
    emails: [],
    phones: [],
  },
};
